export const SET_SPECIFIC_PDF_FILE = "SET_SPECIFIC_PDF_FILE";
export const SET_PDF_FILE_NAME = "SET_PDF_FILE_NAME";
export const SAVE_PDF_FILE_AS_ARRAY = "SAVE_PDF_FILE_AS_ARRAY";
export const RESET_FILE_STATE = "RESET_FILE_STATE";

export const SET_IMAGE_URL = "SET_IMAGE_URL";
export const SET_IMAGE_ICON_URL = "SET_IMAGE_ICON_URL";
export const RESET_STATE_IMAGE = "RESET_STATE_IMAGE";
